// removed by extract-text-webpack-plugin
module.exports = {"List":"_3Np0e","ListItem":"_1FZ5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelNearby/NearbyList/NearbyList.scss
// module id = 923
// module chunks = 0